<template>
  <div @click="clickOverlay()" aria-labelledby="bsModalLabel" class="modal fade" data-backdrop="static"
       data-keyboard="false" data-toggle="modal"
       id="bsModalNewsletterTemplate" role="dialog" tabindex="-1">
    <div @click.stop class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button @click="close()" aria-label="Close" class="close" type="button"><span
            aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-left" id="bsModalLabel">{{ title }}</h4>
        </div>
        <div class="modal-body text-center">
          <div v-html="newsletterTemplate"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsletterTemplateModal',
  data() {
    return {
      title: '',
      newsletterTemplate: ''
    }
  },
  methods: {
    clickOverlay: function() {
      // Hide modal
      this.close()
    },
    close() {
      $('#bsModalNewsletterTemplate').modal('hide')
    }
  },
  mounted() {
    this.$bus.$on('newsletter-template-modal', (args) => {
      this.title = args.title
      this.newsletterTemplate = args.data || null
      $('#bsModalNewsletterTemplate').modal('show')
    })
  }
}
</script>

<style scoped></style>
